import React, { useState, useEffect, useContext, useRef   } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/TopUp.css';
import useForm from "../../../services/UseForm";
import validate from '../../../validations/admin/member/topupValidate';
import axios from "axios";
import { API } from "../../../services/api";
import { UserContext, AlertContext } from "../../../App";
import { useReactToPrint } from 'react-to-print';
import '../../../css/MemberBill.css';
import exiticon from '../../../img/icon/mainMenu/exit.png';
import Alert from "../../../components/alert";


axios.defaults.baseURL = API;

class ComponentToPrint extends React.PureComponent {
    render() {
        function currencyFormat(num) {
            if (num !== "") {
                return Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
        }
        const billDetails = this.props.BillDetails;
        const productList = this.props.TemProductList;
        const today = Date.now();
        const dateNow = (new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(today));
        return (
            <div className="MemberBillContent">
                <div className="BillHeader">
                    <div className="BillTitle">
                        <span>Manee Cafe</span>
                    </div>
                    <div className="BillTitle">
                          <span>Top Up Member</span>
                      </div>
                    <div className="Cashier">
                        <span>Bill NO: {billDetails.BillNO}</span>
                    </div>
                    <div className="Cashier">
                        <span>Cashier: {billDetails.cashier}</span>
                    </div>
                    <div className="ShowDate">
                        <span>Date: {dateNow}</span>
                    </div>
                    <div className="LocationName">
                        <span>Location: {billDetails.LocationName}</span>
                    </div>
                </div>
                <div className="footer-line"></div>
                <div className="footer-line"></div>
                <div className="BillDetail">
                    <div className="MemberNO">
                        <span>Card Number:</span>
                        <strong>{billDetails.MemberNO}</strong>
                    </div>
                    <div className="TopUpAmount">
                        <span>Previous Amount:</span>
                        <strong>{currencyFormat(billDetails.PreviousAmount)}</strong>
                    </div>
                    <div className="TopUpAmount">
                        <span>Top Up Amount:</span>
                        <strong>{currencyFormat(billDetails.TopUpAmount)}</strong>
                    </div>
                    <div className="TopUpAmount">
                        <span>NetTotal:</span>
                        <strong>{currencyFormat(billDetails.SubTotal)}</strong>
                    </div>
                    <div className="footer-line"></div>
                    <div className="footer-line"></div>
                    <div className="paymentType">
                        <span>PaymentType:</span>
                        <strong>{billDetails.PaymentType}</strong>
                    </div>
                   
                    <div className="paidAmount">
                        <span>PaidAmount:</span>
                        <strong>{currencyFormat(billDetails.PaidAmount)}</strong>
                    </div>
                  
                    <div className="changeAmount">
                        <span>Change:</span>
                        <strong>{currencyFormat(billDetails.ChangeAmount)}</strong>
                    </div>
                    <div className="footer-line"></div>
                    {/* <span>----------------------------------------------------------------------</span> */}
                    <div className="Thankyou">
                        <span>Thank you!</span>
                    </div>
                </div>
            </div>
        );
    }
  }

function TopUp() {

    function getDate() {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        return `${year}-${month}-${date} ${time}`;
    }
  const {showAlert, setShowAlert, errorMessage, setErrorMessage} = useContext(AlertContext);
  const componentRef = useRef();
  const {userID, UserName, LocationID, LocationName, showForm, setShowForm, setshowSubmenu, Address, Tell, device, setDevice, status, setStatus, EPSON_VENDOR_ID} = useContext(UserContext);
  const [PaymentTypeList, setPaymentTypeList] = useState([]);
  const [PaymentTypeID, setPaymentTypeID] = useState(0);
  const [BillNO, setBillNO] = useState("");
  const [PrintCount, setPrintCount] = useState(1);
  const [loading, setLoading] = useState(false);


    const handleInputPrintCount = event => { 
        const { name, value } = event.target;
        setPrintCount(value)
    };

  function currencyFormat(num) {
    if (num > 0) 
        return Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    else
        return 0
  }

    const connectPrinter = async () => {
        try {
            setStatus('Connecting...');
            
            // Request permission to access the USB device
            const selectedDevice = await navigator.usb.requestDevice({
                filters: [{ vendorId: EPSON_VENDOR_ID }]
            });

            await selectedDevice.open();
            
            // Select configuration (most USB printers use configuration 1)
            if (selectedDevice.configuration === null) {
                await selectedDevice.selectConfiguration(1);
            }
            
            // Claim the primary interface (usually interface 0)
            await selectedDevice.claimInterface(0);

            setDevice(selectedDevice);
            setStatus(`Connected to: ${selectedDevice.productName || 'Epson Printer'}`);
            } catch (error) {
                console.error('USB Connection Error:', error);
                setStatus(`Connection failed: ${error.message}`);
            }
    };

    let receipt = '';
    const ESC = '\x1B';
    const GS = '\x1D';
    const CMD = {
        INIT: ESC + '@',             // Initialize printer
        ALIGN_LEFT: ESC + 'a\x00',   // Left alignment
        ALIGN_CENTER: ESC + 'a\x01', // Center alignment
        ALIGN_RIGHT: ESC + 'a\x02',  // Right alignment
        FONT_NORMAL: ESC + '!', // Select normal font (Font A)
        FONT_Size: ESC + '!' + 1,     
        FONT_SizeNomal: ESC + '!' + 0,    
        FONT_BOLD: ESC + 'E\x01',    // Turn on bold
        FONT_REGULAR: ESC + 'E\x00', // Turn off bold
        FEED_CUT: GS + 'V\x41\x03',  // Feed paper and cut (Partial cut)
    };

  // Utility to pad out text to exactly 42 characters for flawless right alignment
    const formatLeftRight = (leftText, rightText, maxChars = 48) => {
        const spacesNeeded = maxChars - (leftText.length + rightText.length);
        if (spacesNeeded <= 0) {
        return leftText.substring(0, maxChars - rightText.length - 1) + ' ' + rightText + '\n';
        }
        return leftText + ' '.repeat(spacesNeeded) + rightText + '\n';
    };

    const PrintBillDetail = (gTransactionID) => {
        setLoading(true);
        let receipt = '';

        // 1. Initialize Printer
        receipt += CMD.INIT;

        // 2. Header Section (Centered)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + 'Manee Arabica Coffee'.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += `${Address}\n`;
        receipt += `Tel: (+856) ${Tell}\n`;
        receipt += '-'.repeat(48) + '\n'; // Divider

        // 3. Metadata Section (Left Aligned)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + `TOPUP`.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += CMD.ALIGN_LEFT;
        receipt += `BILL ID# ${gTransactionID}\n`;
        receipt += `Date: ${new Date().toLocaleDateString()}\n`;
        receipt += `Cashier: ${UserName}\n`;
        receipt += '-'.repeat(48) + '\n';
        // 5. Totals Section
        receipt += formatLeftRight("MemberNO:", `${values.MemberNO}`);
        receipt += formatLeftRight("Name:", `${values.Name}`);
        receipt += formatLeftRight("Previous Amount:", `${currencyFormat(values.PreviousAmount)}`);
        receipt += formatLeftRight("TopUp Amount:", `${currencyFormat(values.TopUpAmount)}`);
        receipt += '='.repeat(48) + '\n';
        // Bold total row
        receipt += CMD.FONT_BOLD;
        receipt += formatLeftRight("TOTAL:", `${currencyFormat(values.SubTotal)}`);
        receipt += CMD.FONT_REGULAR;
        receipt += '='.repeat(48) + '\n';

        receipt += formatLeftRight("PaymentType:", `${values.PaymentType}`);
        receipt += formatLeftRight("PaidAmount:", `${currencyFormat(values.PaidAmount)}`);
        receipt += formatLeftRight("ChangeAmount:", `${currencyFormat(values.ChangeAmount)}`);
        

        

        receipt += '='.repeat(48) + '\n';

        // 6. Footer & Auto-Cut
        receipt += CMD.ALIGN_CENTER;
        receipt += "Thank you for your visit!\n";
        receipt += "Please come again\n\n\n\n"; // Feeds space before cutting
        receipt += CMD.FEED_CUT;

        // Convert string to Uint8Array for binary transmission
        const encoder = new TextEncoder();
        const uint8Array = encoder.encode(receipt);
        
        setLoading(false);
        return uint8Array;
    };

  const handlePrintBill = async (gTransactionID) => {
    if(device){
        const endpointOut = device.configuration.interfaces[0].alternate.endpoints.find(
            (ep) => ep.direction === 'out' && ep.type === 'bulk'
        );
        const endpointNumber = endpointOut.endpointNumber;
        const rawBuffer = PrintBillDetail(gTransactionID);
        await device.transferOut(endpointNumber, rawBuffer);
    } else {
        connectPrinter();
    }
    
    // Example hook for connecting to WebUSB or Bluetooth native API
    // await sendToPrinter(rawBuffer);
  };
 
  const handleSearchMember = e => {
    const { name, value } = e.target;
    handleChange(name, value);
    if(value){
        SearchMember(value);
    } else {

    }
  }

  async function SearchMember(memberNO) {
    let token = localStorage.getItem("token");
    var data = {
        MemberNO: memberNO
    }
    await axios.post("/searchMember", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        let memberData = response?.data;
        if(memberData.length > 0){
            handleChange("MemberID", memberData[0].MemberID);
            handleChange("Name", memberData[0].FirstName + ' ' + memberData[0].LastName);
            handleChange("PreviousAmount", memberData[0].Amount );
        } else {
            handleChange("MemberID", "");
            handleChange("Name", "");
            handleChange("PreviousAmount", "0" );
            handleChange("TopUpAmount", "0" );
            handleChange("PaidAmount", "0" );
            handleChange("SubTotal", "0" );
        }

    }).catch((err) => {
        console.log(err);
        handleChange("MemberID", "");
        handleChange("Name", "");
        handleChange("PreviousAmount", "0" );
        handleChange("TopUpAmount", "0" );
        handleChange("PaidAmount", "0" );
        handleChange("SubTotal", "0" );
    });
};

  const handleTopUpAmount = (e) => {
    const { name, value } = e.target;
      const re = /^[0-9\b]+$/;
      if (value) {
          if (value === '' || re.test(value.split(',').join(''))) {
            if(Number(value.split(',').join('')) <= 5000000){
              handleChange(name, value.split(',').join(''));
              const subTotal = Number(value.split(',').join('')) + Number(values.PreviousAmount);
              handleChange("SubTotal", subTotal);
            } else {
              handleChange(name, 0);
              handleChange("SubTotal", 0);
            }
          }  
      } else {
          handleChange("SubTotal", 0);
          handleChange(name, 0);
      }
  }

  const handlePaidAmount = event => {
    const { name, value } = event.target;
      const re = /^[0-9\b]+$/;
      if (value) {
          if (value === '' || re.test(value.split(',').join(''))) {
              handleChange(name, value.split(',').join(''));
              const change = Number(value.split(',').join('')) - Number(values.TopUpAmount.split(',').join(''));
              handleChange("ChangeAmount", change);
          }  
      } else {
          handleChange(name, value);
          handleChange("ChangeAmount", 0);
      }
  }

  const handleSelectPaymentType = (e) => {
    var data = PaymentTypeList.filter(function (item) {
        return item.PaymentType === e.target.value
    })
    if (data.length > 0) {
        setPaymentTypeID(data[0].PaymentTypeID);
        handleChange("PaymentType", data[0].PaymentType);
        handleChange("PaymentTypeID", data[0].PaymentTypeID);
    } else {
        handleChange("PaymentType", "");
        handleChange("PaymentTypeID", "");
    }
};

async function saveTutorial() {
    if(Number(values.PaidAmount) >= Number(values.TopUpAmount)){
        if(device){
            connectPrinter();
        }
        let token = localStorage.getItem("token");
        var data = {
            MemberID: values.MemberID,
            PaymentTypeID: values.PaymentTypeID,
            TopUpAmount: values.TopUpAmount,
            PreviousAmount: values.PreviousAmount,
            SubTotal: values.SubTotal,
            CreateByID: userID,
            CreateDate: getDate(),
            LocationID: LocationID,
            StatusID: 1,
        }
        await axios.post("/topupmember", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            // PrintPaymentBill(response?.data?.insertId);
            handlePrintBill(response?.data?.insertId);
            ClearData();
        }).catch((err) => {
            console.log(err);
        });
    } else {
        setErrorMessage("ຍອດຈ່າຍບໍ່ພຽງພໍ");
        setShowAlert(true);
    }
};

async function PrintPaymentBill (TransactionID) {
    let token = localStorage.getItem("token");
    var data = {
        PaymentType: values.PaymentType, 
        BillNumber: TransactionID,
        userName: UserName, 
        TopUpAmount: values.TopUpAmount,
        PreviousAmount: values.PreviousAmount,
        SubTotal: values.SubTotal,
        PaidAmount: values.PaidAmount, 
        ChangeAmount: values.ChangeAmount, 
        MemberNO: values.MemberNO, 
        CustomerName: values.Name, 
        Address: Address,
        Tell: Tell,
        PrintCount: PrintCount,
    }
    await axios.post("/printTopUp", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
    }).catch((err) => {
        console.log(err);
    });
}

const handlePrint = useReactToPrint({
    content: () => componentRef.current,
});

const ClearData = () => {
    handleChange("MemberNO", "");
    handleChange("MemberID", "");
    handleChange("MemberID", "");
    handleChange("Name", "");
    handleChange("PreviousAmount", "0" );
    handleChange("TopUpAmount", "0" );
    handleChange("PaidAmount", "0" );
    handleChange("SubTotal", "0" );
}

const handleclickBack = () => {
    setShowForm(false);
    setshowSubmenu(true);
};


const {
    values,
    errors,
    handleChange,
    handleSubmit,
  } = useForm(saveTutorial, validate);

  useEffect(() => {

    let paymentData = localStorage.getItem("paymentTypeData");
    if (paymentData) {
      let userRole = JSON.parse(paymentData);
      setPaymentTypeList(userRole);
    }

  }, []);

  return (
    <div className="TopUpMemberFormContent">
         <Alert/> 
        <form onSubmit={handleSubmit} noValidate className="topupform">
            <div className="leftContent">
                <div className="leftHeader">
                    <div className="topupleftTitle">
                        <span>ເຕີມບັດ Member</span>
                    </div>
                </div>
                <div className="leftBody">
                    <div className="topupitem">
                        <div className="txtMemberNo">
                            <span>ເລກບັດ Member</span>
                            <input className={`input form-control ${errors.MemberNO && 'is-invalid'}`} type="text" name="MemberNO" onChange={(e) => handleSearchMember(e)}  value={values.MemberNO || ''} required />
                            {errors.MemberNO && (
                            <p className="invalid-feedback">{errors.MemberNO}</p>
                            )}
                        </div>
                        <div className="txtTopUpAmount">
                            <span>ຍອດເຕີມບັດ</span>
                            <input className={`input form-control ${errors.TopUpAmount && 'is-invalid'}`} type="text" name="TopUpAmount" onChange={(e) => handleTopUpAmount(e)} value={currencyFormat(values.TopUpAmount) || ''} required disabled={!values.Name} />
                            {errors.TopUpAmount && (
                            <p className="invalid-feedback">{errors.TopUpAmount}</p>
                            )}
                        </div>
                        <div className="txtPaidAmount">
                            <span>ຍອດຈ່າຍ</span>
                            <input className={`input form-control ${errors.PaidAmount && 'is-invalid'}`} type="text" name="PaidAmount" onChange={(e) => handlePaidAmount(e)} value={currencyFormat(values.PaidAmount) || ''} required disabled={!values.TopUpAmount} />
                            {errors.PaidAmount && (
                            <p className="invalid-feedback">{errors.PaidAmount}</p>
                            )}
                        </div>
                        <div className="cbPaymentType">
                            <label>ປະເພດຈ່າຍ: </label>
                            <select name="PaymentTypeID" onChange={(e) => handleSelectPaymentType(e)}
                                className={`input form-control ${errors.PaymentTypeID && 'is-invalid'}`}>
                                <option
                                    key={""}
                                    value={""}
                                >
                                    {'ເລືອກປະເພດຈ່າຍ'}
                                </option>
                                {   PaymentTypeList && PaymentTypeList.map(item => (
                                    <option
                                        key={item.PaymentTypeID}
                                        value={item.PaymentType}
                                    >
                                        {item.PaymentType}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="rightContent">
                <div className="header">
                        <span className="text">ຂໍ້ມູນບັດ Member</span>
                    </div>
                <div className="rightBody">
                    
                    <div className="gMemberNo">
                        <span >ເລກບັດ:</span>
                        <span >{values.MemberNO}</span>
                    </div>

                    <div className="gName">
                        <span >ຊື່ລູກຄ້າ:</span>
                        <span>{values.Name}</span>
                    </div>
                    
                    <div className="gPreviousAmout">
                        <span >ຍອດເຫຼືອ:</span>
                        <span>{currencyFormat(values.PreviousAmount)}</span>
                    </div>
                    
                    <div className="gTopupAmout">
                        <span >ຍອດຕື່ມບັດ:</span>
                        <span>{currencyFormat(values.TopUpAmount)}</span>
                    </div>
                    
                    <div className="gSubtotal">
                        <span >ຍອດລວມ:</span>
                        <span >{currencyFormat(values.SubTotal)}</span>
                    </div>
                    
                    <div className="header2">
                        <span>ຂໍ້ມູນການຈ່າຍ</span>
                    </div>
                    <div className="gPaidAmout">
                        <span>ຍອດຈ່າຍ:</span>
                        <strong>{currencyFormat(values.PaidAmount)}</strong>
                    </div>
                    <div className="gChangeAmount">
                        <span>ເງິນທອນ:</span>
                        <strong>{currencyFormat(values.ChangeAmount)}</strong>
                    </div>
                       
                    <div className="rightFooter">
                        <button type="submit" className="btn btn-primary btnPayment" >ຈ່າຍເງິນ</button>
                        <button className="btn btn-danger btnBack" onClick={() => handleclickBack()} >Back</button>
                        <div className="headerPrintcount">
                            <span>ຈຳນວນບິນ:</span>
                            <input className="PrintCount" type="text" name="PrintCount" placeholder="1" onChange={(e) => handleInputPrintCount(e)} value={PrintCount} required />
                        </div>
                    
                    </div>
                    
                </div>
            </div>
        </form>
      </div>
  );
};

export default TopUp;
